import PropTypes from "prop-types"

import Column from "../../../common/components/Column"
import ConditionalPurpleLinearProgress from "../../../common/components/ConditionalLinearProgress"
import AuthLiquidSurface from "./AuthLiquidSurface"

export default function LoadingPaper({ isLoading, children }) {
  return (
    <Column sx={{ width: "100%", alignItems: "center" }}>
      <ConditionalPurpleLinearProgress visible={isLoading} />
      <AuthLiquidSurface
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
          p: { xs: 2.5, sm: 3 },
          overflow: "visible",
        }}
      >
        {children}
      </AuthLiquidSurface>
    </Column>
  )
}

LoadingPaper.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.any,
}
